var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "dialog-base",
    {
      attrs: {
        visible: _vm.visible,
        title: "Hướng dẫn thiết lập & quản lý gói học phí",
        size: "lg",
        "cancel-text": "Đóng",
        "confirm-text": "Đã hiểu",
        "use-panel": false,
        "append-to-body": true,
        top: "5vh",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        confirm: _vm.handleClose,
        cancel: _vm.handleClose,
      },
    },
    [
      _c("div", { staticClass: "pkg-guide" }, [
        _c("div", { staticClass: "pkg-guide-section" }, [
          _c("p", { staticClass: "pkg-guide-title" }, [
            _c("i", { staticClass: "el-icon-user pkg-guide-icon" }),
            _vm._v(" 1) Mô hình chu kỳ học phí theo từng học sinh\n      "),
          ]),
          _c("p", { staticClass: "pkg-guide-desc" }, [
            _vm._v("\n        Gói học phí "),
            _c("strong", [_vm._v("không có ngày bắt đầu/kết thúc tổng thể")]),
            _vm._v(
              ". Thay vào đó, mỗi học sinh có chu kỳ riêng bắt đầu từ ngày học sinh được thêm vào gói:\n      "
            ),
          ]),
          _c("div", { staticClass: "pkg-guide-cards-3" }, [
            _c("div", { staticClass: "pkg-guide-time-card" }, [
              _c("span", { staticClass: "pkg-guide-time-num" }, [_vm._v("1")]),
              _c("div", [
                _c("strong", [_vm._v("Cách tính & thu học phí")]),
                _c("p", [
                  _vm._v(
                    "Khoảng thời gian được tính tiền trong 1 lần thu (ví dụ: thu 3 tháng/lần, 1 năm/lần)."
                  ),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "pkg-guide-time-card" }, [
              _c("span", { staticClass: "pkg-guide-time-num" }, [_vm._v("2")]),
              _c("div", [
                _c("strong", [_vm._v("Chu kỳ của từng học sinh")]),
                _c("p", [
                  _vm._v(
                    "Bắt đầu từ ngày học sinh tham gia vào gói. Mỗi học sinh có thể có ngày bắt đầu khác nhau."
                  ),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "pkg-guide-time-card" }, [
              _c("span", { staticClass: "pkg-guide-time-num" }, [_vm._v("3")]),
              _c("div", [
                _c("strong", [_vm._v("Khoảng trên phiếu thu")]),
                _c("p", [
                  _vm._v(
                    "Khoảng áp dụng hiển thị cho phụ huynh lấy từ startValidityPeriod / endValidityPeriod của phiếu thu."
                  ),
                ]),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "pkg-guide-formula mt-2" }, [
            _c("code", [
              _vm._v("Ngày bắt đầu chu kỳ 1 = Ngày học sinh tham gia gói"),
            ]),
          ]),
          _c("div", { staticClass: "pkg-guide-formula" }, [
            _c("code", [
              _vm._v(
                "Ngày bắt đầu chu kỳ N+1 = Ngày kết thúc chu kỳ N + 1 ngày"
              ),
            ]),
          ]),
          _c("p", { staticClass: "pkg-guide-example mt-1" }, [
            _vm._v("\n        Ví dụ: Học sinh A tham gia ngày "),
            _c("strong", [_vm._v("01/08/2026")]),
            _vm._v(", gói thu 3 tháng/lần:"),
            _c("br"),
            _vm._v("\n        → Chu kỳ 1: "),
            _c("strong", [_vm._v("01/08/2026 – 31/10/2026")]),
            _c("br"),
            _vm._v("\n        → Chu kỳ 2: "),
            _c("strong", [_vm._v("01/11/2026 – 31/01/2027")]),
            _c("br"),
            _vm._v("\n        Nếu học sinh B tham gia ngày "),
            _c("strong", [_vm._v("15/08/2026")]),
            _vm._v(", chu kỳ đầu của B là "),
            _c("strong", [_vm._v("15/08/2026 – 14/11/2026")]),
            _vm._v(".\n      "),
          ]),
        ]),
        _c("div", { staticClass: "pkg-guide-section" }, [
          _c("p", { staticClass: "pkg-guide-title" }, [
            _c("i", { staticClass: "el-icon-edit-outline pkg-guide-icon" }),
            _vm._v(" 2) Chi tiết các trường cấu hình gói\n      "),
          ]),
          _c("ul", [
            _c("li", [
              _c("strong", [_vm._v("Đơn vị tính học phí:")]),
              _vm._v(
                " Chọn Hàng tháng, Hàng năm, Hàng ngày hoặc Thu một lần.\n        "
              ),
            ]),
            _c("li", [
              _c("strong", [_vm._v("Số đơn vị thu mỗi lần:")]),
              _vm._v(
                " Số tháng/năm/ngày được thu trong một lần. Ví dụ: Hàng tháng và số 3 → Thu 3 tháng mỗi lần.\n        "
              ),
            ]),
            _c("li", [
              _c("strong", [_vm._v("Cho phép tự động gia hạn:")]),
              _vm._v(
                " Bật chính sách gia hạn cho gói. Mỗi lần gia hạn sẽ tạo một chu kỳ mới theo đúng cách tính học phí.\n          "
              ),
              _c("em", [
                _vm._v(
                  "Nhân viên vẫn cần vào danh sách để chọn học sinh được gia hạn."
                ),
              ]),
            ]),
            _c("li", [
              _c("strong", [_vm._v("Nhắc lần đầu trước hạn (ngày):")]),
              _vm._v(
                " Số ngày trước khi hết hạn sẽ bắt đầu nhắc. Ví dụ: 10 → Nhắc trước 10 ngày.\n        "
              ),
            ]),
            _c("li", [
              _c("strong", [_vm._v("Nhắc lại mỗi (ngày/lần):")]),
              _vm._v(
                " Sau lần nhắc đầu, hệ thống tiếp tục nhắc lại theo tần suất này cho đến khi hết hạn. Ví dụ: 3 → Nhắc mỗi 3 ngày.\n          "
              ),
              _c("div", { staticClass: "pkg-guide-highlight" }, [
                _c("i", { staticClass: "el-icon-warning" }),
                _vm._v(
                  " Nếu không muốn nhắc lại, để trống trường này. Hệ thống chỉ nhắc đúng một lần vào ngày đã thiết lập. Hủy tự động gia hạn không xóa lịch nhắc của chu kỳ hiện tại; sau ngày hết hạn thì dừng.\n          "
                ),
              ]),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "pkg-guide-section" }, [
          _c("p", { staticClass: "pkg-guide-title" }, [
            _c("i", { staticClass: "el-icon-bell pkg-guide-icon" }),
            _vm._v(" 3) Ví dụ lịch nhắc hạn\n      "),
          ]),
          _c("p", { staticClass: "pkg-guide-desc" }, [
            _vm._v("Chu kỳ hết hạn "),
            _c("strong", [_vm._v("31/10/2026")]),
            _vm._v(", nhắc lần đầu "),
            _c("strong", [_vm._v("10 ngày")]),
            _vm._v(" trước, nhắc lại "),
            _c("strong", [_vm._v("mỗi 3 ngày")]),
            _vm._v(":"),
          ]),
          _c("div", { staticClass: "pkg-guide-reminder-list" }, [
            _c("div", { staticClass: "pkg-guide-reminder-item" }, [
              _c("span", { staticClass: "pkg-guide-reminder-date" }, [
                _vm._v("21/10/2026"),
              ]),
              _c("span", [_vm._v("Nhắc lần đầu (trước 10 ngày)")]),
            ]),
            _c("div", { staticClass: "pkg-guide-reminder-item" }, [
              _c("span", { staticClass: "pkg-guide-reminder-date" }, [
                _vm._v("24/10/2026"),
              ]),
              _c("span", [_vm._v("Nhắc lại lần 2 (+ 3 ngày)")]),
            ]),
            _c("div", { staticClass: "pkg-guide-reminder-item" }, [
              _c("span", { staticClass: "pkg-guide-reminder-date" }, [
                _vm._v("27/10/2026"),
              ]),
              _c("span", [_vm._v("Nhắc lại lần 3 (+ 3 ngày)")]),
            ]),
            _c("div", { staticClass: "pkg-guide-reminder-item" }, [
              _c("span", { staticClass: "pkg-guide-reminder-date" }, [
                _vm._v("30/10/2026"),
              ]),
              _c("span", [_vm._v("Nhắc lại lần 4 (+ 3 ngày)")]),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "pkg-guide-section" }, [
          _c("p", { staticClass: "pkg-guide-title" }, [
            _c("i", { staticClass: "el-icon-document-copy pkg-guide-icon" }),
            _vm._v(" 4) Các ví dụ cấu hình thực tế\n      "),
          ]),
          _c("div", { staticClass: "pkg-guide-example-card" }, [
            _c(
              "p",
              { staticClass: "pkg-guide-example-title" },
              [
                _c("el-tag", { attrs: { type: "success", size: "mini" } }, [
                  _vm._v("Ví dụ phổ biến"),
                ]),
                _vm._v(
                  " Thu 3 tháng, nhắc trước 10 ngày, nhắc lại 3 ngày\n        "
                ),
              ],
              1
            ),
            _c("div", { staticClass: "pkg-guide-example-body" }, [
              _c("p", [
                _c("strong", [_vm._v("Cấu hình:")]),
                _vm._v(" Đơn vị tính: "),
                _c("em", [_vm._v("Hàng tháng")]),
                _vm._v(" | Số đơn vị: "),
                _c("em", [_vm._v("3")]),
                _vm._v(" | Tự động gia hạn: "),
                _c("em", [_vm._v("Bật")]),
                _vm._v(" | Nhắc đầu: "),
                _c("em", [_vm._v("10 ngày")]),
                _vm._v(" | Nhắc lại: "),
                _c("em", [_vm._v("3 ngày/lần")]),
              ]),
              _c("p", { staticClass: "pkg-guide-example-result" }, [
                _c("i", { staticClass: "el-icon-right" }),
                _c("strong", [_vm._v("Diễn giải:")]),
                _vm._v(
                  " Học phí thu 3 tháng/lần. Trước khi hết hạn 10 ngày bắt đầu nhắc, sau đó nhắc mỗi 3 ngày. Khi hết chu kỳ, hệ thống tự tạo chu kỳ mới 3 tháng tiếp theo.\n          "
                ),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "pkg-guide-example-card" }, [
            _c(
              "p",
              { staticClass: "pkg-guide-example-title" },
              [
                _c("el-tag", { attrs: { type: "primary", size: "mini" } }, [
                  _vm._v("Ví dụ đơn giản"),
                ]),
                _vm._v(" Thu 1 tháng, chỉ nhắc 1 lần\n        "),
              ],
              1
            ),
            _c("div", { staticClass: "pkg-guide-example-body" }, [
              _c("p", [
                _c("strong", [_vm._v("Cấu hình:")]),
                _vm._v(" Đơn vị tính: "),
                _c("em", [_vm._v("Hàng tháng")]),
                _vm._v(" | Số đơn vị: "),
                _c("em", [_vm._v("1")]),
                _vm._v(" | Tự động gia hạn: "),
                _c("em", [_vm._v("Bật")]),
                _vm._v(" | Nhắc đầu: "),
                _c("em", [_vm._v("5 ngày")]),
                _vm._v(" | Nhắc lại: "),
                _c("em", [_vm._v("để trống")]),
              ]),
              _c("p", { staticClass: "pkg-guide-example-result" }, [
                _c("i", { staticClass: "el-icon-right" }),
                _c("strong", [_vm._v("Diễn giải:")]),
                _vm._v(
                  " Thu học phí mỗi tháng. Nhắc 1 lần duy nhất vào 5 ngày trước khi hết hạn.\n          "
                ),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "pkg-guide-example-card" }, [
            _c(
              "p",
              { staticClass: "pkg-guide-example-title" },
              [
                _c("el-tag", { attrs: { type: "info", size: "mini" } }, [
                  _vm._v("Ví dụ thu một lần"),
                ]),
                _vm._v(" Phí nhập học, đồng phục\n        "),
              ],
              1
            ),
            _c("div", { staticClass: "pkg-guide-example-body" }, [
              _c("p", [
                _c("strong", [_vm._v("Cấu hình:")]),
                _vm._v(" Đơn vị tính: "),
                _c("em", [_vm._v("Thu một lần")]),
                _vm._v(" | Tự động gia hạn: "),
                _c("em", [_vm._v("Đã khóa (không áp dụng)")]),
              ]),
              _c("p", { staticClass: "pkg-guide-example-result" }, [
                _c("i", { staticClass: "el-icon-right" }),
                _c("strong", [_vm._v("Diễn giải:")]),
                _vm._v(
                  " Chỉ thu 1 lần duy nhất. Hệ thống không tạo chu kỳ tiếp theo.\n          "
                ),
              ]),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "pkg-guide-section" }, [
          _c("p", { staticClass: "pkg-guide-title" }, [
            _c("i", { staticClass: "el-icon-guide pkg-guide-icon" }),
            _vm._v(" 5) Quy trình vận hành 4 bước\n      "),
          ]),
          _c("div", { staticClass: "pkg-guide-steps" }, [
            _c("div", { staticClass: "pkg-guide-step-item" }, [
              _c("span", { staticClass: "pkg-guide-step-num" }, [_vm._v("1")]),
              _c("div", { staticClass: "pkg-guide-step-content" }, [
                _c("strong", [_vm._v("Khởi tạo gói học phí")]),
                _c("p", [
                  _vm._v(
                    "Điền thông tin gói, chọn đơn vị thu và thiết lập cấu hình nhắc hạn / tự động gia hạn."
                  ),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "pkg-guide-step-item" }, [
              _c("span", { staticClass: "pkg-guide-step-num" }, [_vm._v("2")]),
              _c("div", { staticClass: "pkg-guide-step-content" }, [
                _c("strong", [_vm._v("Thêm học sinh vào gói")]),
                _c("p", [
                  _vm._v("Nhấn biểu tượng "),
                  _c("em", [_vm._v("Quản lý thành viên")]),
                  _vm._v(
                    " (hình người). Ngày tham gia = ngày bắt đầu chu kỳ 1."
                  ),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "pkg-guide-step-item" }, [
              _c("span", { staticClass: "pkg-guide-step-num" }, [_vm._v("3")]),
              _c("div", { staticClass: "pkg-guide-step-content" }, [
                _c("strong", [_vm._v("Đăng ký tự động gia hạn")]),
                _c("p", [
                  _vm._v("Nhấn biểu tượng "),
                  _c("em", [_vm._v("Quản lý tự động gia hạn")]),
                  _vm._v(" (hình xoay vòng) để chọn học sinh áp dụng."),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "pkg-guide-step-item" }, [
              _c("span", { staticClass: "pkg-guide-step-num" }, [_vm._v("4")]),
              _c("div", { staticClass: "pkg-guide-step-content" }, [
                _c("strong", [_vm._v("Hệ thống tự động xử lý")]),
                _c("p", [
                  _vm._v(
                    "Khi đến hạn, hệ thống tạo chu kỳ mới và khởi tạo phiếu thu tương ứng cho học sinh đã đăng ký."
                  ),
                ]),
              ]),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "pkg-guide-tip" }, [
          _c("i", { staticClass: "el-icon-magic-stick" }),
          _c("strong", [_vm._v("Mẹo:")]),
          _vm._v(
            " Trong quá trình thao tác trên biểu mẫu, bạn có thể rê chuột vào biểu tượng dấu hỏi chấm "
          ),
          _c("i", { staticClass: "el-icon-question" }),
          _vm._v(
            " cạnh từng ô nhập liệu để xem giải thích nhanh tại chỗ.\n    "
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }